module.exports = __webpack_public_path__ + "static/EWY_Shar-917cb4bc1b607520a8a257128abb4538.png";